import { openDB, type IDBPDatabase } from 'idb';
// 数据库配置
const DB_NAME = 'muset-token';
const DB_VERSION = 2;
// 缓存新数据库名称
let cachedDBName: string | null = null;
// 获取正确的 indexedDB 引用
// function getIndexedDB(): IDBFactory | null {
//   if (typeof self !== 'undefined' && typeof window === 'undefined') {
//     // Web Worker 环境
//     return self.indexedDB || null;
//   } else if (typeof window !== 'undefined') {
//     // 浏览器主线程环境
//     return window.indexedDB || null;
//   }
//   return null;
// }

// 统一的数据库初始化函数
// async function initAuthDB() {
//   return await openDB(DB_NAME, DB_VERSION, {
//     upgrade(db) {
//       // 创建 tokens store

//       if (!db.objectStoreNames.contains('tokens')) {
//         db.createObjectStore('tokens', { keyPath: 'endpoint' });
//       }
//       // 创建 uids store
//       if (!db.objectStoreNames.contains('userIds')) {
//         db.createObjectStore('userIds', { keyPath: 'endpoint' });
//       }
//     },
//     blocked() {
//       console.warn('Database upgrade was blocked');
//     },
//     blocking() {
//       console.warn('Database is blocking other connections');
//     },
//   }).catch(async error => {
//     console.error('Failed to open IndexedDB:', error);
//     await indexedDB.deleteDatabase(DB_NAME);
//     console.log('Deleted corrupted database, recreating...');

//     // 等待一小段时间确保删除完成
//     await new Promise(resolve => setTimeout(resolve, 100));

//     // 重新创建数据库
//     return await openDB(DB_NAME, DB_VERSION, {
//       upgrade(db) {
//         if (!db.objectStoreNames.contains('tokens')) {
//           db.createObjectStore('tokens', { keyPath: 'endpoint' });
//         }
//         if (!db.objectStoreNames.contains('userIds')) {
//           db.createObjectStore('userIds', { keyPath: 'endpoint' });
//         }
//       },
//     }).catch(error => {
//       console.error('Failed to open IndexedDB:', error);
//       return createLocalStorageFallback();
//     });
//   });
//   // } catch (error) {
//   //   console.error('Failed to open IndexedDB:', error);

//   //   // 捕获 IndexedDB 错误，特别是 backing store 错误

//   //   console.warn('IndexedDB error detected, attempting recovery...', error);

//   //   try {
//   //     // 尝试删除损坏的数据库并重新创建
//   //     await indexedDB.deleteDatabase(DB_NAME);
//   //     console.log('Deleted corrupted database, recreating...');

//   //     // 等待一小段时间确保删除完成
//   //     await new Promise(resolve => setTimeout(resolve, 100));

//   //     // 重新创建数据库
//   //     return await openDB(DB_NAME, DB_VERSION, {
//   //       upgrade(db) {
//   //         if (!db.objectStoreNames.contains('tokens')) {
//   //           db.createObjectStore('tokens', { keyPath: 'endpoint' });
//   //         }
//   //         if (!db.objectStoreNames.contains('userIds')) {
//   //           db.createObjectStore('userIds', { keyPath: 'endpoint' });
//   //         }
//   //       },
//   //     });
//   //   } catch (recoveryError) {
//   //     console.error('Failed to recover IndexedDB:', recoveryError);

//   //     // 如果恢复失败，尝试降级到 localStorage（可选）
//   //     console.warn('Attempting to use localStorage as fallback...');
//   //     return createLocalStorageFallback();
//   //   }

//   //   // 重新抛出其他类型的错误
//   // }
//   // return await openDB('muset-token', 2, {
//   //   upgrade(db) {
//   //     // 创建 tokens store
//   //     if (!db.objectStoreNames.contains('tokens')) {
//   //       db.createObjectStore('tokens', { keyPath: 'endpoint' });
//   //     }
//   //     // 创建 uids store
//   //     if (!db.objectStoreNames.contains('userIds')) {
//   //       db.createObjectStore('userIds', { keyPath: 'endpoint' });
//   //     }
//   //   },
//   // });
// }
// 创建 localStorage 降级方案（可选）
// function createLocalStorageFallback() {
//   console.warn('Using localStorage fallback for token storage');

//   // 返回一个模拟 IndexedDB 接口的对象
//   return {
//     get: (storeName: string, key: string) => {
//       try {
//         const data = localStorage.getItem(`${storeName}_${key}`);
//         return data ? JSON.parse(data) : undefined;
//       } catch {
//         return undefined;
//       }
//     },
//     put: (storeName: string, value: any) => {
//       try {
//         localStorage.setItem(
//           `${storeName}_${value.endpoint}`,
//           JSON.stringify(value)
//         );
//       } catch (error) {
//         console.error('Failed to store in localStorage:', error);
//       }
//     },
//     delete: (storeName: string, key: string) => {
//       try {
//         localStorage.removeItem(`${storeName}_${key}`);
//       } catch (error) {
//         console.error('Failed to delete from localStorage:', error);
//       }
//     },
//     close: () => {
//       // localStorage 不需要关闭
//     },
//   };
// }

// async function initAuthDB() {
//   return openDB(DB_NAME, DB_VERSION, {
//     upgrade(db) {
//       try {
//         // 创建 tokens store
//         if (!db.objectStoreNames.contains('tokens')) {
//           db.createObjectStore('tokens', { keyPath: 'endpoint' });
//         }
//         // 创建 uids store
//         if (!db.objectStoreNames.contains('userIds')) {
//           db.createObjectStore('userIds', { keyPath: 'endpoint' });
//         }
//       } catch (upgradeError) {
//         console.error('Error during upgrade:', upgradeError);
//         throw upgradeError;
//       }
//     },
//     blocked() {
//       console.warn('Database upgrade was blocked');
//     },
//     blocking() {
//       console.warn('Database is blocking other connections');
//     },
//   }).catch(async error => {
//     console.error('Failed to open IndexedDB:', error);

//     // 策略1：尝试删除损坏的数据库并重新创建
//     if (await tryRecoverDatabase()) {
//       try {
//         return await initAuthDB(); // 递归重试
//       } catch (retryError) {
//         console.error('Failed to open IndexedDB:', retryError);
//       }
//     }

//     // // 策略2：尝试降级到较低版本
//     // if (await tryDowngradeVersion()) {
//     //   return await initAuthDB(); // 递归重试
//     // }

//     // 策略3：Web Worker 兼容的降级方案
//     console.warn('All recovery attempts failed, using localStorage fallback');
//     return createWorkerCompatibleFallback();
//   });
// }

// 策略1：删除损坏的数据库并重新创建
// async function tryRecoverDatabase(): Promise<boolean> {
//   try {
//     console.log('Attempting to recover database by deletion...');

//     let indexedDB = window.indexedDB;
//     if (!indexedDB) return false;

//     // 删除损坏的数据库
//     await new Promise<void>((resolve, reject) => {
//       const deleteRequest = indexedDB.deleteDatabase(DB_NAME);
//       deleteRequest.onsuccess = () => resolve();
//       deleteRequest.onerror = event => {
//         console.log('eeeeeeeerrorEvent', event);
//         indexedDB = self.indexedDB;
//         if (!indexedDB) return reject();
//         const deletcRequestNew = indexedDB.deleteDatabase(DB_NAME);
//         deletcRequestNew.onsuccess = () => resolve();
//         deletcRequestNew.onerror = event => {
//           console.error('Failed to delete database:tryRecover', event);
//           return resolve();
//         };
//         // return resolve();
//       };
//     });

//     console.log('Database deleted successfully, waiting for cleanup...');

//     // 等待删除完成并清理
//     await new Promise(resolve => setTimeout(resolve, 200));

//     // 尝试重新创建
//     const testDB = await openDB(DB_NAME, DB_VERSION, {
//       upgrade(db) {
//         if (!db.objectStoreNames.contains('tokens')) {
//           db.createObjectStore('tokens', { keyPath: 'endpoint' });
//         }
//         if (!db.objectStoreNames.contains('userIds')) {
//           db.createObjectStore('userIds', { keyPath: 'endpoint' });
//         }
//       },
//     });

//     await testDB.close();
//     console.log('Database recovery successful');
//     return true;
//   } catch (error) {
//     console.error('Database recovery failed:', error);
//     return false;
//   }
// }

// // 策略2：尝试降级到较低版本
// async function tryDowngradeVersion(): Promise<boolean> {
//   try {
//     console.log('Attempting to downgrade database version...');

//     // 尝试版本 1
//     const testDB = await openDB(DB_NAME, 1, {
//       upgrade(db) {
//         if (!db.objectStoreNames.contains('tokens')) {
//           db.createObjectStore('tokens', { keyPath: 'endpoint' });
//         }
//         if (!db.objectStoreNames.contains('userIds')) {
//           db.createObjectStore('userIds', { keyPath: 'endpoint' });
//         }
//       },
//     });

//     await testDB.close();
//     console.log('Database downgrade successful');
//     return true;
//   } catch (error) {
//     console.error('Database downgrade failed:', error);
//     return false;
//   }
// }

// // 策略3：localStorage 降级方案
// // 策略3：Web Worker 兼容的降级方案
function createWorkerCompatibleFallback() {
  console.warn('Using worker-compatible fallback for token storage');

  // 使用内存存储作为降级
  const memoryStore = new Map<string, any>();

  return {
    get: async (storeName: string, key: string) => {
      const fullKey = `${storeName}_${key}`;
      return memoryStore.get(fullKey);
    },
    put: async (storeName: string, value: any) => {
      const fullKey = `${storeName}_${value.endpoint}`;
      memoryStore.set(fullKey, value);
      return value;
    },
    delete: async (storeName: string, key: string) => {
      const fullKey = `${storeName}_${key}`;
      return memoryStore.delete(fullKey);
    },
    close: () => {
      // 内存存储不需要关闭
    },
  };
}
// 统一的数据库接口类型
type DatabaseInterface =
  | IDBPDatabase<unknown>
  | {
      get: (storeName: string, key: string) => Promise<any>;
      put: (storeName: string, value: any) => Promise<any>;
      delete: (storeName: string, key: string) => Promise<boolean>;
      close: () => void;
    };

// 生成新的数据库名称，避免损坏的数据库
function generateNewDBName(): string {
  const timestamp = Date.now();
  const random = Math.random().toString(36).substring(2, 8);
  return `${DB_NAME}_${timestamp}_${random}`;
}

// 尝试使用新数据库名称
async function tryCreateNewDatabase(): Promise<DatabaseInterface | null> {
  if (cachedDBName) {
    try {
      const db = await openDB(cachedDBName, DB_VERSION, {
        upgrade(db) {
          if (!db.objectStoreNames.contains('tokens')) {
            db.createObjectStore('tokens', { keyPath: 'endpoint' });
          }
          if (!db.objectStoreNames.contains('userIds')) {
            db.createObjectStore('userIds', { keyPath: 'endpoint' });
          }
        },
      });
      console.log(`Successfully opened cached database: ${cachedDBName}`);
      return db;
    } catch (error) {
      console.warn(
        `Cached database ${cachedDBName} failed, creating new one:`,
        error
      );
      cachedDBName = null; // 清除缓存
    }
  }
  const newDBName = generateNewDBName();
  console.log(`Attempting to create new database: ${newDBName}`);

  try {
    const db = await openDB(newDBName, DB_VERSION, {
      upgrade(db) {
        if (!db.objectStoreNames.contains('tokens')) {
          db.createObjectStore('tokens', { keyPath: 'endpoint' });
        }
        if (!db.objectStoreNames.contains('userIds')) {
          db.createObjectStore('userIds', { keyPath: 'endpoint' });
        }
      },
    });
    console.log(`Successfully created new database: ${newDBName}`);
    return db;
  } catch (error) {
    console.error(`Failed to create new database ${newDBName}:`, error);
    return null;
  }
}

// 修改 initAuthDB 函数
async function initAuthDB() {
  // 首先尝试使用原始数据库名称
  try {
    return await openDB(DB_NAME, DB_VERSION, {
      upgrade(db) {
        try {
          if (!db.objectStoreNames.contains('tokens')) {
            db.createObjectStore('tokens', { keyPath: 'endpoint' });
          }
          if (!db.objectStoreNames.contains('userIds')) {
            db.createObjectStore('userIds', { keyPath: 'endpoint' });
          }
        } catch (upgradeError) {
          console.error('Error during upgrade:', upgradeError);
          throw upgradeError;
        }
      },
      blocked() {
        console.warn('Database upgrade was blocked');
      },
      blocking() {
        console.warn('Database is blocking other connections');
      },
    });
  } catch (error) {
    console.error('Failed to open original database:', error);

    // 如果原始数据库失败，尝试创建新数据库
    const newDB = await tryCreateNewDatabase();
    if (newDB) {
      return newDB;
    }

    // 如果所有尝试都失败，使用内存存储降级
    console.warn(
      'All database creation attempts failed, using memory fallback'
    );
    return createWorkerCompatibleFallback();
  }
}

export async function readEndpointToken(
  endpoint: string
): Promise<string | null> {
  const idb = await initAuthDB();
  const token = await idb.get('tokens', endpoint);
  return token ? token.token : null;
}

export async function writeEndpointToken(endpoint: string, token: string) {
  const db = await initAuthDB();
  await db.put('tokens', { endpoint, token });
}

export async function deleteEndpointToken(endpoint: string) {
  const db = await initAuthDB();
  await db.delete('tokens', endpoint);
}

export async function readEndpointUserId(
  endpoint: string
): Promise<string | null> {
  const idb = await initAuthDB();
  const userId = await idb.get('userIds', endpoint);
  return userId ? userId.userId : null;
}

export async function writeEndpointUserId(endpoint: string, userId: string) {
  const db = await initAuthDB();
  await db.put('userIds', { endpoint, userId });
}

export async function deleteEndpointUserId(endpoint: string) {
  const db = await initAuthDB();
  await db.delete('userIds', endpoint);
}
